<template>
  <v-container text-xs-center>
    <div class="standards_wrapper elevation-5">
      <!-- <vue-pivottable-ui
        :data="standartsItems"
        :rows="['eventName','Rank','classification']"
        :cols="['gender','facilityType']"
        :vals="['standardTime']"
        :aggregatorName="'List Unique Values'"
        :rowTotal="false"
        :colTotal="false">
      </vue-pivottable-ui> -->
      <!--Second toolbar-->
      <!-- <v-tabs
        v-model="tabs"
        color="white"
        dark
        background-color="light-blue darken-4"
        show-arrows
        fixed-tabs
      >
        <v-tabs-slider color="white"></v-tabs-slider>
        <v-tab
          cy-data="cy_item_gender-facility"
          v-for="(item, index) in standardsList.filter(
            (el) => el.classification == this.classType
          )"
          :key="index"
          :value="item.gender"
        >
          {{ `${item.gender} ${item.facilityType}` }}
        </v-tab>
        <v-tabs-items v-model="tabs">
          <v-tab-item
            v-for="(subitem, indx) in standardsList.filter(
              (el) => el.classification == this.classType
            )"
            :key="indx"
          >
            <v-data-table
              :headers="headers"
              :items="tableList"
              :search="search"
              :class="{ mobile: isMobile }"
              :loading="loading"
              loading-text="Loading, please wait..."
              class="elevation-3"
              group-key="node.setLibSetId"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              hide-default-footer
              @page-count="pageCount = $event"
              item-key="node.standardId"
            >
              <template v-slot:[`item.node.setLibSetId`]="{ item }">
                <v-chip color="green" small class="p-2" text-color="white">
                  {{ getEventName(item.node.setLibSetId) }}
                </v-chip>
              </template>
              <template v-slot:[`item.node.rankId`]="{ item }">
                <v-chip small class="p-2" text-color="primary">{{
                  getRank(item.node.rankId)
                }}</v-chip>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="edit(item.node)">
                  edit
                </v-icon>
                <v-icon
                  small
                  @click="deleteCurrentStandard(item.node.standardId)"
                >
                  delete
                </v-icon>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs> -->
      <pivot-table
        :data="standartsItems"
        :inProfileName="profileName"
        :pivotProps="pivotProps"
        v-show="standartsItems.length !== 0"
      >
      </pivot-table>
    </div>
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        color="light-blue darken-4"
        :length="pageCount"
      ></v-pagination>
    </div>
  </v-container>
</template>

<script>
/* eslint-disable prettier/prettier */
import { mapGetters } from "vuex";
// import standardsForm from "../forms/standardsForm.vue";
// import catValueDropDown from "../shared/cat_val_dropdown.vue";
import PivotTable from '../views/common/Report/PIvotTable.vue';
// import { VuePivottableUi } from 'vue-pivottable'
import 'vue-pivottable/dist/vue-pivottable.css'

//TODO Take out headers information
//TODO Create crud operations for standards

export default {
  name: "StandardsPivotLib",
  props: {
    classType: {
      type: String,
      default: "",
    },
    rankId: {
      type: Number,
      default: 0,
    },
    eventId: {
      type: Number,
      default: 0,
    },
    profileName: {
    type: String,
    default: '',
  },
  },
  emits: ["edit-standard"],
  mounted() {
    console.log("Pivot mounted with", this.classType, this.rankId, this.eventId);
  },
  components: {
    // standardsForm,
    // catValueDropDown,
    // VuePivottableUi,
    PivotTable
  },
  data() {
    return {
      localProfileName: this.profileName,
      pivotProps: {},
      addStandard: false,
      loading: true,
      page: 1,
      dataToEdit: false,
      itemsPerPage: 100,
      pageCount: 0,
      tabs: "",
      search: "",
      setId: 0,
      standardId: "",
      facilityType: null,
      bestOnly: "Y",
      fromDate: "2017-03-13",
      toDate: new Date().toISOString().substr(0, 10),
      isMobile: false,
      menu: false,
      menu1: false,
      gender: null,
      editedIndex: -1,
      //TODO Take out headers
      headers: [
        {
          text: "Event",
          align: "left",
          sortable: true,
          value: "node.setLibSetId",
          class: ["column-color"],
        },
        {
          text: "Rank",
          align: "left",
          sortable: true,
          value: "node.rankId",
          class: ["column-color"],
        },
        {
          text: "Time to achieve",
          align: "left",
          sortable: true,
          value: "node.standardTime",
          class: ["column-color"],
        },
        {
          text: "Classification",
          align: "left",
          sortable: true,
          value: "node.classification",
          class: ["column-color"],
        },

        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  async created() {
    this.setDefaultPivotProps();
      // Populate from route only if not set via props
  if (!(Object.entries(this.$route.query).length === 0)) {
    const { profileName } = this.$route.query;
    this.localProfileName = profileName;
  }
    Promise.all([
      this.$store.dispatch("getStandardsList"),
      this.$store.dispatch("allStandards"),
      this.$store.dispatch("allRankLib"),
      this.$store.dispatch("allSetsLib"),
    ])
      .then(() => {
        console.log(this.allStandards);
        this.loading = false;
      })
      .catch((error) => {
        console.error(error);
        this.loading = false;
      });
  },
  computed: {
    rankList() {
      if (this.rankLib && this.rankLib.edges && this.rankLib.edges.length > 0) {
        return this.rankLib.edges.filter(
          (el) => el.node.rankClassification == this.classType
        )
      } else {
        return []
      }
    },

    standartsItems() {
  if (this.allStandards && this.allStandards.edges && this.allStandards.edges.length > 0) {
        // console.log('this.allStandards.edges=', this.allStandards.edges)
        // console.log('this.setId=', this.setId)
        // console.log('this.rankId=', this.rankId)
        // console.log('this.classType=', this.classType)
    const result = this.allStandards.edges.filter(
      (el) => (
            (this.eventId === 0 || !this.eventId || Number(this.eventId) === Number(el.node.setLibSetId)) &&
        (this.rankId === 0 || !this.rankId || Number(this.rankId) === el.node.rankId) &&
        (!this.classType || this.classType === el.node.classification)
      )
    ).map(
      standard => {
        const nodeDetails = standard.node
        const rankInfo = this.getRankInfo(nodeDetails.rankId)
        return {
          classification: nodeDetails.classification,
              // comments: nodeDetails.comments,
          facilityType: nodeDetails.facilityType,
          gender: nodeDetails.gender,
          rankId: nodeDetails.rankId,
          rankCode: rankInfo ? rankInfo.rankCode : '',
          rankName: rankInfo ? rankInfo.rankName : '',
          rankDesc: rankInfo ? rankInfo.rankDesc : '',
          Rank: this.getRank(nodeDetails.rankId),
          eventId: nodeDetails.setLibSetId,
          eventName: this.getEventName(nodeDetails.setLibSetId),
              // standardId: nodeDetails.standardId,
              // standardTime: nodeDetails.standardTime,
          standardTime: (nodeDetails.standardTime.replace(/(\.[0-9]*[1-9])0+$|\.0*$/,'$1')).replaceAll("00:","")
        }
      }
    )
        // console.log('result=',result)
    return result
  } else {
    return []
  }
},

    // tableList() {
    //   if (this.currentTab[0] && this.$store.getters.allStandards.edges) {
    //     const result = this.$store.getters.allStandards.edges
    //       .filter((el) => {
    //         return this.setId === 0 || !this.setId
    //           ? //? +el.node.setLibSetId === +this.eventsList[0].node.setId
    //             true
    //           : +el.node.setLibSetId === +this.setId;
    //       })
    //       .filter(
    //         (el) =>
    //           el.node.facilityType === this.currentTab[0].facilityType &&
    //           el.node.gender === this.currentTab[0].gender &&
    //           el.node.classification == this.classType
    //       );
    //     return !this.rankId || this.rankId === 0
    //       ? result
    //       : result.filter((r) => +r.node.rankId === +this.rankId);
    //   } else {
    //     return [];
    //   }
    // },

    currentTab() {
      return this.standardsList.filter((_, indx) => indx === this.tabs) || [];
    },
    eventsList() {
      if (this.setsLib.edges) {
        const sets = this.setsLib.edges.filter((el) =>
          String(el.node.tag).match(new RegExp("OLYMPIC"))
        );
        return sets.reduce((a, b) => {
          if (a.length === 0) {
            a.push(b);
          } else {
            if (a.some((e) => e.node.distance === b.node.distance) === false) {
              a.push(b);
            }
          }
          return a;
        }, []);
      } else {
        return [];
      }
    },
    ...mapGetters(["standardsList", "allStandards", "rankLib", "setsLib"]),
    formTitle() {
      return this.editedIndex === -1 ? "New standard" : "Edit standard";
    },
  },

  watch: {
    profileName(newVal) {
    console.log("New profile name:", newVal);
    // do something with it...
  },
  dialog(val) {
    val || this.close();
  },
    // "$route.params.club": function() {
    //   this.$store.dispatch("allResultsList", {
    //     clubId: this.$route.params.club
    //   });
    // },
},

  methods: {
    getRankInfo(rankId) {
      if (this.rankLib.edges) {
        const rank = this.rankLib.edges.find(item => item.node.rankId == rankId)
        return rank ? rank.node : null
      }
      return null
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    close() {
      this.editedIndex = -1;
      this.addStandard = false;
    },
    edit(item) {
      this.dataToEdit = Object.assign({}, item);
      this.addStandard = true;
      this.editedIndex = 1;
    },
    deleteCurrentStandard(id) {
      this.loading = true;
      this.$store
        .dispatch("deleteStandard", {
          standardId: id,
        })
        .then(() => {
          this.loading = false;
          this.$toast.error("Standard has been deleted");
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
        });
    },
    getEventName(itemId) {
      if (this.setsLib.edges) {
        const item = this.setsLib.edges.filter(
          (i) => +i.node.setId == +itemId
        )[0];
        if (item && item.node.distance && item.node.stroke) {
          return `${item.node.distance} ${item.node.stroke}`;
        }
      }
      // return this.categoryValue.edges
      //   .filter(category => category.node.category)
      //   .filter(category => category.node.category.catName == "SPORT_TYPE");
    },
    getRank(itemId) {
      if (this.rankLib.edges) {
        const rank = this.rankLib.edges.find(item => item.node.rankId == itemId)
        return rank ? rank.node.rankDesc : 'Unknown Rank';
      } else {
        return "Loading...";
      }
// return this.categoryValue.edges
//   .filter(category => category.node.category)
      //   .filter(category => category.node.category.catName == "SPORT_TYPE");
    },
    setDefaultPivotProps() {
      this.pivotProps.aggregatorName = "List Unique Values";
      this.pivotProps.rendererName = "Table";
      this.pivotProps.rowOrder = "key_a_to_z";
      this.pivotProps.colOrder = "key_a_to_z";
      this.pivotProps.vals = ["standardTime"];
      this.pivotProps.cols = ["gender", "facilityType"];
      this.pivotProps.rows = ["eventName", "Rank", "classification", "rankCode"];
    }
  },
};
</script>

<style lang="scss" scoped>
.v-input {
  padding-top: 0 !important;
}
.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid var(--v-primary-base);
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid var(--v-secondary-base);
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
  text-align: left;
}

.cells-format {
  background: #9ee4ff;
  color: #16365c;
  font-size: 13px;
  border: 2px solid #16365c;
  font: small-caps bold 24px/1 sans-serif;
}

.cells-center {
  background: #16365c;
  color: white;
}

.column-color {
  background: #16365c;
  color: white !important;
  border: 2px solid white;
}
</style>
